'use client';
import { CurrentUrlContext } from '@repo/ui/src/context/CurrentUrlProvider';
import { useContext, useState, useEffect } from 'react';

const useCurrentUrl = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const ctx = useContext(CurrentUrlContext);

  if (!mounted) {
    return { ...ctx, eCommEnabled: false, enableBazaarvoice: false };
  }

  return ctx;
};

export default useCurrentUrl;
